

<template>
    <!-- 佣金订单列表 -->
    <div class="each-order commission" v-if="type === 'commission'">
        <div class="order-top commission">
            <div class="t-left t-left-commission">
                <div>订单编号：{{ item.orderNum }}</div>
                <div>下单时间：{{ item.orderTime }}</div>
            </div>
            <div class="t-right commission">
                <!-- <div v-if="item.settleStatusName === '待入账'" class="key-green">
                    {{item.settleStatusName}}
                </div>
                <div v-if="item.settleStatusName === '待结算'"  class="key-orange">
                    {{item.settleStatusName}}
                </div>
                 <div v-if="item.settleStatusName === '已结算'">
                    {{item.settleStatusName}}
				</div>-->
                <div v-if="item.settleStatusName === '已失效'" class="key-gray">
                    {{ item.settleStatusName }}
                </div>
            </div>
        </div>
        <div class="order-center commission">
            <img class="preview" :src="item.thumbnail" alt />
            <div class="detail-wra commission">
                <div>
                    <div
                        class="row1 multiple-text-overflow"
                        v-text="item.productName"
                    ></div>
                </div>
                <div
                    v-if="
                        item.orderType < 4 ||
                        item.orderType == 21 ||
                        item.orderType == 22
                    "
                >
                    <div
                        class="row2 text-overflow"
                        v-text="item.specsName"
                    ></div>
                </div>
                <div class="row2" v-else-if="item.orderType == 5">
                    {{ item.orderDays }}晚
                </div>
                <!-- <div class="row2" v-else-if="item.orderType == 8">{{item.quantity}}份</div> -->
                <div class="row3">
                    <div class="count" v-if="item.orderType < 4">
                        <span>{{ item.quantity }}份</span>
                    </div>
                    <div class="count" v-else-if="item.orderType == 5">
                        <span>{{ item.quantity }}间</span>
                    </div>
                    <div class="count" v-else>
                        <span>x {{ item.quantity }}</span>
                    </div>
                    <div class="price">
                        <span class="suffix">￥</span>
                        <span class="price">{{ item.factFee }}</span>
                    </div>
                    <span v-if="item.cashPledge" class="yajin"
                        >(含可退押金￥{{
                            item.cashPledge * item.quantity
                        }})</span
                    >
                </div>
            </div>
        </div>
        <div class="order-bottom commission">
            <div class="commission-wraper">
                <div class="key">
                    <span>
                        佣金:
                        <span
                            >￥{{
                                (item.commission > 0 && item.commission) ||
                                (item.bounty > 0 && item.bounty) ||
                                0
                            }}</span
                        >
                    </span>
                </div>
                <div
                    class="key wait"
                    v-if="item.commission > 0 || item.bounty > 0"
                >
                    <span>{{
                        (item.commission > 0 && "(自动结算)") ||
                        (item.bounty > 0 && "(手动结算)")
                    }}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- 普通用户的订单列表 -->
    <div class="each-order" v-else>
        <div class="order-top">
            <div class="t-left">
                <img
                    :src="instinctImage(item.type)"
                    @error="__change__no__image"
                    class="title-icon"
                />
                <span class="instinct-title">{{
                    instinctTitle[item.type]
                }}</span>
                <!-- <span class="order-number">{{item.orderNo}}</span> -->
            </div>
            <div class="t-right" :class="getStatusColor(item.status)">
                {{
                    getStatusText(
                        item.status,
                        item.isInAfterSale && item.afterSaleStatus
                    )
                }}
            </div>
        </div>
        <div class="order-center" @click="$listeners.click">
            <img class="preview" :src="item.thumbnail" alt />
            <div class="detail-wra">
                <div
                    v-if="
                        item.type === 9 || item.type === 10 || item.type === 11
                    "
                >
                    <div
                        class="row1 multiple-text-overflow"
                        v-text="getname(item)"
                    ></div>
                </div>
                <div v-else-if="item.type < 4">
                    <div
                        class="row1 multiple-text-overflow"
                        v-text="item.productName"
                    ></div>
                    <div
                        class="row2 multiple-text-overflow"
                        v-text="item.specsName"
                    ></div>
                </div>
                <div v-else-if="item.type === 5">
                    <div
                        class="row1 text-overflow"
                        v-text="getname(item)"
                    ></div>
                    <div
                        class="row2 text-overflow"
                        v-text="gettypename(item)"
                    ></div>
                </div>
                <div
                    v-else
                    class="row1 multiple-text-overflow"
                    v-text="getpname(item)"
                ></div>

                <div class="row2" v-if="item.type == 5">
                    {{ getUseTime(item.startDate) }} 入住
                    <span class="ml25"
                        >共{{
                            getDurationDay(item.startDate, item.endDate)
                        }}晚</span
                    >
                </div>
                <div class="row2" v-else-if="item.type == 8">
                    {{ item.quantity }}份
                </div>
                <div class="row2" v-else-if="item.type == 6">
                    <span v-if="item.specName" class="mr25"
                        >规格：{{ item.specName }}</span
                    >
                    <span>x{{ item.quantity }}</span>
                </div>
                <div
                    class="row2"
                    v-else-if="
                        item.type == 9 ||
                        item.type == 10 ||
                        item.type == 11 ||
                        item.type < 4
                    "
                >
                    <span v-if="item.useTime">{{
                        getUseTime(item.useTime)
                    }}</span>
                </div>
                <div
                    class="row2"
                    v-else-if="item.type == 21 || item.type == 22"
                >
                    <span v-if="item.specsName">{{ item.specsName }}</span>
                </div>

                <div class="row3">
                    <div class="count" v-if="item.type < 4">
                        <span>{{ item.quantity }}份</span>
                    </div>
                    <div class="count" v-else-if="item.type === 5">
                        <span>{{ item.quantity }}间</span>
                    </div>
                    <div class="count" v-else>
                        <span>x {{ item.quantity }}</span>
                    </div>
                    <div class="price">
                        <span class="suffix">￥</span>
                        <span class="price">{{ item.factFee }}</span>
                    </div>
                    <span v-if="item.cashPledge" class="yajin"
                        >(含可退押金￥{{
                            item.cashPledge * item.quantity
                        }})</span
                    >
                </div>
                <!-- <div class="row3">
                    <div></div>
                    <span class="suffix">￥</span>
                    <span class="price">{{item.factFee}}</span>
                    <span
                        v-if="item.cashPledge"
                        class="yajin"
                    >(含可退押金￥{{item.cashPledge * item.quantity}})</span>
				</div>-->
            </div>
        </div>
        <div class="order-bottom">
            <!-- 景区 -->
            <template v-if="item.type < 4">
                <template v-if="item.status == 1">
                    <div class="btn" @click="cancelOrder(item)">取消订单</div>
                    <div class="btn gold" @click="submitOrder(item)">
                        <!-- <img v-if="isCostLoading" :src="loadingSrc" class="loading" /> -->
                        <span>去支付</span>
                    </div>
                </template>
                <template v-else-if="item.status == 50 || item.status == 80">
                    <div
                        class="btn"
                        @click="toRefund(item)"
                        v-if="
                            item.afterSaleStatus != 11 &&
                            item.afterSaleStatus != 10
                        "
                    >
                        申请退款
                    </div>
                </template>
                <template v-else-if="item.status == 70 || item.status == 71">
                    <div class="btn" @click="deleteOrder(item)">删除订单</div>
                </template>
                <template
                    v-else-if="
                        item.status == 90 ||
                        item.status == 100 ||
                        item.status == 25
                    "
                >
                    <div class="btn" @click="deleteOrder(item)">删除订单</div>
                </template>
            </template>
            <!-- 酒店、线路、包车、露营 -->
            <template
                v-if="
                    item.type == 5 ||
                    item.type == 9 ||
                    item.type == 10 ||
                    item.type == 11
                "
            >
                <template v-if="item.status == 1">
                    <div class="btn" @click="cancelOrder(item)">取消订单</div>
                    <div class="btn gold" @click="submitOrder(item)">
                        <img
                            v-if="isCostLoading"
                            :src="loadingSrc"
                            class="loading"
                        />
                        <span v-else>去支付</span>
                    </div>
                </template>
                <template v-else-if="item.status == 10">
                    <a
                        class="btn primary"
                        v-if="item.merchantTel"
                        :href="'tel:' + item.merchantTel"
                        >联系商家</a
                    >
                    <a
                        class="btn primary"
                        v-if="item.supplierContactTel"
                        :href="'tel:' + item.supplierContactTel"
                        >联系商家</a
                    >
                    <div class="btn" @click="toRefund(item)">申请退款</div>
                </template>
                <template v-else-if="item.status == 50">
                    <div
                        class="btn"
                        @click="toRefund(item)"
                        v-if="item.afterSaleStatus != 10"
                    >
                        申请退款
                    </div>
                    <a
                        class="btn primary"
                        v-if="item.merchantTel"
                        :href="'tel:' + item.merchantTel"
                        >联系商家</a
                    >
                    <a
                        class="btn primary"
                        v-if="item.supplierContactTel"
                        :href="'tel:' + item.supplierContactTel"
                        >联系商家</a
                    >
                </template>
                <template v-else-if="item.status == 100 || item.status == 25">
                    <div class="btn" @click="deleteOrder(item)">删除订单</div>
                </template>
                <template v-else-if="item.status == 70 || item.status == 71">
                    <div class="btn" @click="deleteOrder(item)">删除订单</div>
                    <div
                        class="btn primary"
                        v-if="!item.isCommented && item.type != 11"
                        @click="toComment(item)"
                    >
                        去评价
                    </div>
                </template>
            </template>
            <!-- 商品 -->
            <template v-if="item.type == 21 || item.type == 22">
                <template v-if="item.status == 1">
                    <div class="btn" @click="cancelOrder(item)">取消订单</div>
                    <div class="btn gold" @click="submitOrder(item)">
                        <img
                            v-if="isCostLoading"
                            :src="loadingSrc"
                            class="loading"
                        />
                        <span v-else>去支付</span>
                    </div>
                </template>
                <template v-else-if="item.status == 30">
                    <div
                        class="btn"
                        @click="toRefund(item)"
                        v-if="item.afterSaleStatus != 10"
                    >
                        申请退款
                    </div>
                    <a
                        class="btn primary"
                        v-if="item.merchantTel"
                        :href="'tel:' + item.merchantTel"
                        >联系客服</a
                    >
                </template>
                <template v-else-if="item.status == 40">
                    <a
                        class="btn"
                        v-if="item.merchantTel"
                        :href="'tel:' + item.merchantTel"
                        >联系客服</a
                    >
                    <!-- 当不存在售后状态 即货物没进入售后流程时，才能申请退货 -->
                    <div
                        class="btn"
                        @click="toReturn(item)"
                        v-if="!item.afterSaleStatus"
                    >
                        申请退货
                    </div>
                    <!-- 待退货的售后状态才有我要退货按钮 -->
                    <div
                        class="btn primary"
                        @click="toSubmitReturn(item)"
                        v-if="item.afterSaleStatus == 50"
                    >
                        我要退货
                    </div>
                    <div class="btn primary" @click="confirmReceipt(item)">
                        确认收货
                    </div>
                </template>

                <template v-else-if="item.status == 70 || item.status == 71">
                    <div class="btn" @click="deleteOrder(item)">删除订单</div>
                    <div
                        class="btn primary"
                        v-if="!item.isCommented"
                        @click="toComment(item)"
                    >
                        去评价
                    </div>
                </template>
                <template v-else-if="item.status == 100 || item.status == 25">
                    <div class="btn" @click="deleteOrder(item)">删除订单</div>
                </template>
            </template>
            <!-- 美食 -->
            <template v-if="item.type == 8">
                <template v-if="item.status == 1">
                    <div class="btn" @click="cancelOrder(item)">取消订单</div>
                    <div class="btn gold" @click="submitOrder(item)">
                        <img
                            v-if="isCostLoading"
                            :src="loadingSrc"
                            class="loading"
                        />
                        <span v-else>去支付</span>
                    </div>
                </template>
                <template v-else-if="item.status == 20">
                    <div class="btn" @click="cancelOrder(item)">取消订单</div>
                </template>
                <template v-else-if="item.status == 50">
                    <div class="btn" @click="toRefund(item)">申请退款</div>
                </template>
                <template
                    v-else-if="
                        item.status == 100 ||
                        item.status == 25 ||
                        item.status == 70 ||
                        item.status == 71
                    "
                >
                    <div class="btn" @click="deleteOrder(item)">删除订单</div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListOfOrder",
    inheritAttrs: false,
    props: {
        type: String,
        item: Object,
    },
    data() {
        return {
            instinctTitle: {
                1: "景区门票",
                2: "景区门票",
                5: "精选酒店",
                9: "包车线路",
                10: "包车线路",
                21: "文创精品",
                22: "嗨购特产",
                11: "沙漠露营",
            },
            isCostLoading: false,
            hotel: "",
            scene: "",
            goods: "",
            car: "",
            camping: "",
            cyrzSrc: "",
            cdrzSrc: "",
            cysxSrc: "",
            loadingSrc: "",
            list1Src: "",
        };
    },
    inject: ["pullDownRefresh"],
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.cyrzSrc = API.ossUrl + "user/commission/c-yrz.png";
        this.cdrzSrc = API.ossUrl + "user/commission/c-drz.png";
        this.cysxSrc = API.ossUrl + "user/commission/c-ysx.png";
        this.loadingSrc = API.ossUrl + "common/loading.svg";
        this.hotel = API.ossUrl + "user/png/icon-hotel.png";
        this.scene = API.ossUrl + "user/png/icon-scene.png";
        this.goods = API.ossUrl + "user/png/icon-goods.png";
        this.car = API.ossUrl + "user/png/icon-car.png";
        this.camping = API.ossUrl + "user/png/camping.png";
        this.list1Src = API.ossUrl + "user/commission/list-1.png";
    },
    destroyed() {},
    methods: {
        getStatusText(state, afterSaleStatus) {
            return UTILS.getStatusText(state, afterSaleStatus);
        },
        instinctImage(type) {
            //订单类别：1门票  2套票  3押金物品  5房型酒店  6商品 8代金券  9包车 10线路 21文创精品 22特产商品
            switch (Number(type)) {
                case 1:
                    return this.scene;
                    break;
                case 2:
                    return this.scene;
                    break;
                case 3:
                    return this.scene;
                    break;
                case 5:
                    return this.hotel;
                    break;
                case 9:
                    return this.car;
                    break;
                case 10:
                    return this.car;
                    break;
                case 11:
                    return this.camping;
                    break;
                case 21:
                    return this.goods;
                    break;
                case 22:
                    return this.goods;
                    break;
                default:
                    break;
            }
        },
        getDurationDay(s, e) {
            const range = moment.range(s, e);
            const days = range.diff("day");
            return days;
        },
        getpname(item) {
            if (item.type == 8) {
                return item.restaurantName + "（" + item.productName + "）";
            } else if (item.type == 1 && item.specsName) {
                return item.productName + "（" + item.specsName + "）";
            } else {
                return item.productName;
            }
        },
        getname(item) {
            return item.productName.split("（")[0];
        },
        gettypename(item) {
            let name = item.productName.split("（")[1];
            return name.substring(0, name.length - 1);
        },
        getUseTime(time) {
            let newTime = time.split("-");
            return `${newTime[1]}月${newTime[2]}日使用`;
        },
        getStatusColor(status) {
            let isBlack = status >= 70 && status <= 100;
            return { red: status === 1, black: isBlack };
        },
    },
};
</script>


<style scoped lang="scss">
.each-order {
    padding-top: 0.48rem;
    border-bottom: 1px solid #f1f1f1;
    &:last-child {
        margin-bottom: 1.333333rem;
        border-bottom: 0;
    }
    &.commission {
        padding-top: 0;
        margin-bottom: 0.213333rem;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .order-top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.4rem;
        background: $white;
        &.commission {
            padding: 0.32rem 0.533333rem 0;
        }
        .t-left {
            display: flex;
            align-items: center;
            .title-icon {
                width: 0.533333rem;
                height: 0.533333rem;
                margin-right: 0.133333rem;
            }
            .instinct-title {
                color: #444;
                font-size: 16px;
                font-weight: 600;
                margin-right: 0.24rem;
            }
            .order-number {
                font-size: 0.32rem;
                color: $grey4;
            }
        }
        .t-left-commission {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            font-size: 12px;
            font-weight: 400;
            line-height: 0.453333rem;
            color: #999999;
        }
        .t-right {
            color: #f8b356;
            font-size: 0.426667rem;
            font-weight: bold;
            &.red {
                color: #ff6a62;
            }
            &.black {
                color: #444444;
            }
            &.commission {
                font-size: 0.426667rem;
                font-weight: 500;
                line-height: 0.586667rem;
                .key-green {
                    color: #5cd5cd;
                }
                .key-orange {
                    color: #ff9200;
                }
                .key-gray {
                    color: #bfbfbf;
                }
            }
        }
    }
    .order-center {
        padding: 0.533333rem;
        background: $white;
        display: flex;
        padding-bottom: 0;
        &.commission {
            padding-top: 0.32rem;
            padding-bottom: 0.346667rem;
        }
        .preview {
            margin-right: 0.266667rem;
            display: block;
            width: 2.453333rem;
            height: 2.453333rem;
            border-radius: 0.266667rem;
        }
        .detail-wra {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            &.commission {
                position: relative;
            }
            .row1 {
                color: #444444;
                font-weight: 600;
                font-size: 16px;
                margin-bottom: 0.133333rem;
                width: 6.213333rem;
            }
            .row2 {
                display: flex;
                color: #8c8c8c;
                margin-bottom: 0.106667rem;
                font-size: 14px;
                vertical-align: bottom;
                line-height: 0.533333rem;
                &.last-child {
                    margin-bottom: 0;
                }
                span {
                    vertical-align: bottom;
                    font-size: 14px;
                }
                .mr25 {
                    margin-right: 0.25rem;
                }
                .ml25 {
                    margin-left: 0.25rem;
                }
            }
            .row3 {
                display: flex;
                justify-content: space-between;
                &.commission {
                    justify-content: space-between;
                    display: flex;
                    .price {
                        color: #666;
                        font-size: 14px;
                    }
                    .commission-price {
                        color: $blue;
                        font-size: 14px;
                    }
                }
                .count {
                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }
                .price {
                    .suffix {
                        font-size: 12px;
                        color: #444444;
                    }
                    .price {
                        font-size: 16px;
                        color: #444444;
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .order-bottom {
        width: 100%;
        height: 1.92rem;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 0.533333rem;
        background: $white;
        &:empty {
            height: 0.9rem;
        }
        &.commission {
            height: 1.44rem;
            color: #999;
            .commission-wraper {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                width: 100%;
                padding: 0.33rem 0;
                border-top: 1px solid rgba(230, 230, 230, 1);
                .key {
                    display: flex;
                    align-items: center;
                    font-size: 0.426667rem;
                    font-weight: 500;
                    color: #454545;
                    span {
                        span {
                            font-size: 0.426667rem;
                            color: #ff9200;
                        }
                    }
                    img {
                        display: inline-block;
                        width: 0.533333rem;
                        height: 0.533333rem;
                        margin-right: 5px;
                    }
                }
                .wait {
                    color: #999999;
                }
                .order-time {
                    display: inline-block;
                }
            }
        }
        .btn {
            width: 2.4rem;
            height: 0.853333rem;
            border: 1px solid rgba(151, 151, 151, 1);
            color: #8c8c8c;
            background: transparent;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 0.213333rem;
            border-radius: 0.533333rem;
            &.gold {
                background: linear-gradient(
                    90deg,
                    rgba(248, 199, 64, 1) 0%,
                    rgba(245, 149, 38, 1) 100%
                );
                color: $white;
                padding: 0;
                width: 2.4rem;
                height: 0.853333rem;
                box-shadow: 0 0 10px rgba(248, 199, 64, 0.8);
                font-weight: bold;
                border: 0;
            }
            &.gold-line {
                border: 1px solid #f8b356;
                color: #f8b356;
            }
            &.primary {
                background: linear-gradient(
                    90deg,
                    rgba(248, 199, 64, 1) 0%,
                    rgba(245, 149, 38, 1) 100%
                );
                color: $white;
                font-weight: bold;
                border: 0;
                width: 2.4rem;
                height: 0.853333rem;
            }
        }
    }
}
</style>

